import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import routeConstants from '../utils/routeConstants';
import ConditionHelperObj from '../utils/helpers/ConditionHelper';
import { setSignEndRoute, setSignCancelRoute } from '../actions/routingActions';
import i18n from '../utils/i18n';
import './styles/PageMenu.scss';

class PageMenu extends React.Component {
  constructor() {
    super();
    this.routeToSessions = this.routeTo.bind(
      this,
      routeConstants.SESSIONS_ROUTE
    );
    this.routeToCourts = this.routeTo.bind(this, routeConstants.COURTS_ROUTE);
    this.routeToMyBookings = this.routeToMyBookings.bind(this);
    this.routeToAccount = this.routeTo.bind(this, routeConstants.ACCOUNT_ROUTE);
  }

  routeTo(route) {
    this.props.dispatch(push(route));
  }

  routeToMyBookings() {
    if (ConditionHelperObj.isUserLogged()) {
      this.routeTo(routeConstants.MY_BOOKINGS_ROUTE);
    } else {
      this.props.setSignEndRoute(routeConstants.MY_BOOKINGS_ROUTE);
      this.props.setSignCancelRoute(routeConstants.MY_BOOKINGS_ROUTE);
      this.routeTo(routeConstants.SIGNUP_ROUTE);
    }
  }

  render() {
    const { location, showAccount } = this.props;
    return (
      <div className="page-menu">
        <div className="menu">
          <span
            onClick={ this.routeToSessions }
            className={
              location.pathname === routeConstants.SESSIONS_ROUTE
                ? 'chosen'
                : ''
            }
          >
            {i18n.t('header.SESSIONS')}
          </span>
          <span
            onClick={ this.routeToCourts }
            className={
              location.pathname === routeConstants.COURTS_ROUTE
                ? 'chosen'
                : ''
            }
          >
            {i18n.t('header.COURTS')}
          </span>
          <span className="magazine">
            <a href="http://www.deucetennis.com/magazine">
              {i18n.t('header.MAGAZINE')}
            </a>
          </span>
          <span
            onClick={ this.routeToMyBookings }
            className={
              location.pathname === routeConstants.MY_BOOKINGS_ROUTE
                ? 'chosen'
                : ''
            }
          >
            {i18n.t('header.BOOKINGS')}
          </span>
          {showAccount && (
            <span
              onClick={ this.routeToAccount }
              className={
                location.pathname === routeConstants.ACCOUNT_ROUTE ? 'chosen' : ''
              }
            >
              {i18n.t('header.ACCOUNT')}
            </span>
          )}
          {!showAccount && (
            <span className="disabled">
              {i18n.t('header.ACCOUNT')}
            </span>
          )}

        </div>
      </div>
    );
  }
}

PageMenu.propTypes = {
  location: PropTypes.shape({}).isRequired,
  dispatch: PropTypes.func.isRequired,
  setSignEndRoute: PropTypes.func.isRequired,
  setSignCancelRoute: PropTypes.func.isRequired,
  showAccount: PropTypes.bool
};

PageMenu.defaultProps = {
  showAccount: false,
};

const mapDispatchToProps = dispatch => ({
  dispatch,
  setSignEndRoute: route => dispatch(setSignEndRoute(route)),
  setSignCancelRoute: route => dispatch(setSignCancelRoute(route))
});

const mapStateToProps = state => ({
  showAccount: state.config.data && state.config.data.turn_on_payments
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(PageMenu)
);



// WEBPACK FOOTER //
// ./src/components/PageMenu.js